import { render, staticRenderFns } from "./AdvancedSegmentation.vue?vue&type=template&id=2713b2fd&scoped=true&"
import script from "./AdvancedSegmentation.vue?vue&type=script&lang=js&"
export * from "./AdvancedSegmentation.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedSegmentation.vue?vue&type=style&index=0&id=2713b2fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2713b2fd",
  null
  
)

export default component.exports